module.exports = __webpack_public_path__ + "fonts/opensans-lightitalic.8b0486d3.woff";